<!--
 * @Author: luxiangqiang
 * @Date: 2023-02-01 15:01:55
 * @LastEditors: luxiangqiang
 * @LastEditTime: 2023-02-10 10:19:41
-->
<template>
  <div>
    <PrimaryBanner
      bg-color="#FFF0DF"
      bg-image="https://video.reta-inc.com/image/default/757EFD5EFE1F4434A58549B2604311A3-6-2.png"
      :desc-list="[$t('遵守全球隐私法'), $t('本地化合规合同'), $t('专业法律团队支持')]"
    >
      <template #slogan>
        {{ $t('强大的') }}<span style="color: rgba(255, 139, 55, 1)">{{ $t('法律合规') }}</span
        >{{ $t('保障') }}
      </template>
    </PrimaryBanner>
    <div class="main">
      <PrimarySection v-for="(item, index) in content" v-bind="item" :rl="!!(index % 2)" :key="index" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import content from '@/assets/contents/global-legitimate.json';
useSeoHead();
</script>
<style lang="less" scoped>
.main {
  margin-top: 120px;
  margin-bottom: 160px;

  :deep(.list__item) {
    display: flex;
    align-items: center;

    .list__content {
      margin-top: 0;
    }
  }
}

@media screen and (min-width: 800px) {
  .main {
    min-width: 1280px;
    padding: 0 32px;
  }
}

@media screen and (max-width: 800px) {
  .main {
    margin-top: 24px;
    margin-bottom: 40px;
    padding: 0 20px;
    box-sizing: border-box;
  }
}
</style>
